<template>
    <el-row class="main-box">
        <el-col >
				<el-image class="main-box-bg" src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image4.jpg" fit="scale-down"
				    :lazy="true"></el-image>
				<!-- datalist!=null&&datalist.length>0 -->
				<el-col v-if="datalist!=null&&datalist.length>0" class="listdivcls" :xs="{span:22,offset:1}" :sm="{span:22,offset:1}"  :md="{span:22,offset:1}" :lg="{span:20,offset:2}">
					<div  class="itembgcls"  v-for="(itemdata, indexdata) in datalist" :key="indexdata" >
							<div class="flex-row " style="height: 65px;align-items: center;">
								<el-image class="itemimag" :src="require('@/static/day_itrm_ic1.png')" fit="fill"></el-image>
								<span class="itemtext">{{itemdata.amnesicDate}}</span>  
							</div>
							
							<div  class=" flex-row" :class="cidata.status!=1?'cillstitem':'cillstitem2'" v-for="(cidata, indexci) in itemdata.amnesicDetailVoList" :key="indexci" >
								<div class="flex-row" style="flex: 1;padding-left: 20px;align-items: center;" @click="startxx(cidata.id,cidata.status)">	
									<el-image class="itemimag2" :src="getheaditem(cidata)" fit="cover"></el-image>
									<div style="margin-left: 20px;flex: 1;">
										<div>{{userInfos.role==0?cidata.teacherName:cidata.studentName}}</div>
										<div  class="flex-row" style="margin-top: 3px;align-items: center;">
											{{cidata.amnesicClassTime}}
										<el-image style="width: 19px;height: 22px;margin-left: 10px" :src="require('@/static/day_item_ic3.png')" fit="fill"></el-image>
										</div>
									</div>
									
									<el-image style="width: 80px;height: 45px;margin-right: 180px;" :src="require('@/static/day_righjkt_ic.png')" fit="fill"></el-image>
										
								</div>
								<div class="flex-row" style="flex: 1;padding-left: 20px;padding-right: 20px;">
									<el-image class="itemimag3" :src="require('@/static/day_item_ic2.png')" fit="fill"></el-image>
									
									<div class="flex1 flex-column f-justify-center" style="margin-left: 20px;flex: 1;" @click="startxx(cidata.id,cidata.status)">
										<div style="font-weight: bold;">{{cidata.courseName}}</div>
										<div  style="margin-top: 6px;font-size: 18px;">
											上课时间：{{cidata.classTime}}
										</div>
									</div>
									
									<div class="flex-column f-center"  style="color: #0AA26B;font-size: 14px;" @click="print(cidata.attendClassRecordId)">
										<el-image class="imagecd" :src="require('@/static/day_item_ic4.png')" fit="fill"></el-image>
										打印
									</div>
									
								</div>
							</div>
					</div>
				</el-col>
			
				<el-col v-else class="content-box" :xs="{span:22,offset:1}" :sm="{span:22,offset:1}"  :md="{span:22,offset:1}" :lg="{span:20,offset:2}">
				    <div class="flex-column flex1 f-align-center">
				        <img class="no-data" src="../../static/saleClass-nodata.png" alt="">
				        <span>暂无21天抗遺忘，赶快上课吧</span>
				    </div>
				</el-col>
        </el-col>

    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    data() {
        return {
			datalist:[
			]
        }
    },
    computed: {
      ...mapState([
          'userToken',
		   'userInfos',
      ]),
      ...mapGetters(["getUserToken"])
    },
	created() {
	    this.getdata();
	},
    methods: {
		print(id){
			this.$router.push({
			    path: "/day_print",
				query:{
					id:id,
					type:1
				}
			}).catch(e => e)
		},
		startxx(id,status){
			console.log("#####"+id);
			this.$router.push({
			    path: "/day_study",
				query: {
				    id:id,
					status:status
				}
			}).catch(e => e)
		},
		async getdata() {
			
			// console.log("~~~~~~~~"+this.userInfos.role);
			var url="/web/frontUser/student/amnesic21List";
			if(this.userInfos.role==1)
			{
				url="/web/frontUser/teacher/amnesic21List";
			}
			
		    let res = await this.$api.get(url, {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        }
		    });
			if(res.code==200)
			{
				this.datalist=res.data;
			}
		},
		getheaditem(item){
			if (this.userInfos.role==0)
			{
				if(!item.teacherAvatar||item.teacherAvatar == ""){
					if(item.teacherSex==0)
					{
						return require('@/static/mr_head_ic1.jpg')
					}else{
						return require('@/static/mr_head_ic0.jpg')
					}
				}
				return item.teacherAvatar;
			}else{
				if(!item.studentAvatar||item.studentAvatar == ""){
					
					if(item.studentSex==0)
					{
						return require('@/static/mr_head_1ic1.jpg')
					}else{
						return require('@/static/mr_head_1ic0.jpg')
					}
				}
				return item.studentAvatar;
			}
		}
    }
}
</script>

<style lang="scss" scoped>
.main-box {
    width: 100%;
    background: #E5F3F1;
    position: relative;
    .content-box {
        // width: 1195px;
        min-height: 600px;
        border-radius: 20px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 20px 25px;
		margin-bottom: 20px;
		position: relative;
		top: -23px;
		@media screen and (max-width: 768px) {
		    top: -15px;
		}
		}

  .no-data {
            margin-top: 110px;
            width: 338px;
            height: 298px;
        }

    .main-box-bg {
        width: 100%;
        // height: 230px;
        position: relative;
        top: 0;
        left: 0;
    }
	
	.listdivcls{
	  position: relative;
	  top: -23px;
	  @media screen and (max-width: 768px) {
	      top: -15px;
	  }
	}
	
	.itembgcls{
		 cursor: pointer;
		border-radius: 20px;
		background: #FFFFFF;
		padding-bottom: 15px;
		margin-bottom:40px;
		 padding-left:23px ;padding-right: 23px;
	}
	
	.itemimag{
		width: 24px;
		height: 24px;
	}
	
	.itemtext{
		font-family: Source Han Sans CN;
		font-size: 18px;
		font-weight: bold;
		line-height: normal;
		letter-spacing: 0em;
		margin-left: 8px;
			
		font-feature-settings: "kern" on;
		/* 333333 */
		color: #333333;
	}
	.cillstitem{
		 min-height: 114px;
		border-radius: 20px;
		opacity: 1;
		box-sizing: border-box;
		border: 1px solid rgba(10, 162, 107, 0.2);
		margin-bottom: 20px;
		background: #E5F7F1;
		align-items: center;
		
		font-family: 思源黑体;
		font-size: 24px;
		font-weight: normal;
		line-height: normal;
		letter-spacing: 0em;
		font-feature-settings: "kern" on;
		/* 333333 */
		color: #333333;
	}
	
	
	.cillstitem2{
		 min-height: 114px;
		border-radius: 20px;
		opacity: 1;
		box-sizing: border-box;
		border: 1px solid rgba(10, 162, 107, 0.2);
		margin-bottom: 20px;
		background: #DCDFDD;
		align-items: center;
		
		font-family: 思源黑体;
		font-size: 24px;
		font-weight: normal;
		line-height: normal;
		letter-spacing: 0em;
		font-feature-settings: "kern" on;
		/* 333333 */
		color: #333333;
	}
	
	
	.itemimag2{
		width: 74px;
		height: 74px;
		border-radius: 74px;
		border: 1px solid #DEDEDE;
	}
	
	.itemimag3{
		width: 74px;
		height: 74px;
	}
	
	.imagecd{
		width: 24px;
		height: 24px;
		margin-bottom: 2px;
	}
	.imagecd:hover {
		width: 30px;
		height:30px;
	}
}
</style>